import React from 'react'

export default function FlattenPdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="36" fill="currentColor" viewBox="0 0 32 36">
  <path fill="currentColor" fill-opacity=".1" d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z" opacity=".1"/>
  <path fill="currentColor" d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"/>
  <path fill="currentColor" fill-opacity=".1" d="m27 22.69-2.074-1.19-9.037 4.994L7.074 21.5 5 22.69 16 29l11-6.31Z"/>
  <path fill="currentColor" fill-opacity=".1" d="M5 20.31 16 14l11 6.31-11 6.31-11-6.31Z"/>
  <path fill="currentColor" d="m15.893 25.92 8.792-4.858.246-.136.244.14 2.074 1.19.756.434L16 29.576 3.995 22.69l.756-.434 2.321-1.331 8.82 4.996Zm-.007 1.147-.243-.138-8.568-4.854-1.07.614L16 28.423l9.994-5.733-1.073-.617-9.035 4.994Z"/>
  <path fill="currentColor" d="m28.005 20.31-.756.434L16 27.196 4.751 20.744l-.756-.434L16 13.424l12.005 6.886Zm-22 0L16 26.043l9.994-5.733L16 14.576 6.005 20.31Z"/>
  <path fill="currentColor" d="M21.762 15.274a.847.847 0 0 1 0 1.178l-5.186 5.304a.802.802 0 0 1-1.152 0l-5.185-5.304a.847.847 0 0 1 0-1.178.802.802 0 0 1 1.152 0l3.794 3.881V7h1.63v12.155l3.794-3.881a.802.802 0 0 1 1.153 0Z"/>
</svg>

    </div>
  )
}
